import React from 'react';
import { useParams } from 'react-router-dom';
import { SnapFlowProvider } from './context';
import SnapFlowPageContent from './content';

const SnapFlowPage = () => {
  const { virtualPhoneNumber } = useParams();

  return (
    <SnapFlowProvider vpn={virtualPhoneNumber}>
      <SnapFlowPageContent />
    </SnapFlowProvider>
  );
};

export default SnapFlowPage;
